var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#a6fa9f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.838 43.893c3.6.321 6.849-.621 9.796-2.962-3.075-.277-5.133-1.899-6.273-4.948 1.036.145 1.995.155 2.971-.135-3.834-.984-5.413-4.579-5.282-7.03.922.47 1.864.808 2.986.837-1.701-1.309-2.678-2.982-2.91-5.093-.167-1.526.108-2.978.863-4.349 3.634 4.511 8.227 6.992 13.844 7.411-.041-.418-.102-.804-.116-1.189-.112-2.869 1.008-5.064 3.31-6.566 2.456-1.603 5.868-1.201 7.95.918.261.267.481.325.834.232a13.85 13.85 0 0 0 3.706-1.564c.002.874-1.142 2.475-2.68 3.854.394-.077.791-.137 1.181-.232a15.61 15.61 0 0 0 1.232-.356c.392-.133.775-.294 1.164-.443.021.025.043.048.065.073-.536.663-1.046 1.352-1.617 1.978-.457.501-.981.936-1.491 1.381a.56.56 0 0 0-.21.485c.084 4.925-1.311 9.349-4.146 13.243-2.874 3.948-6.663 6.363-11.301 7.253-3.518.675-6.973.396-10.338-.913-1.244-.485-2.429-1.098-3.54-1.885z",
    fill: "#222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(16.838 18.885)",
    d: "M0 0h32.64v28.16H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterRound);
export default __webpack_public_path__ + "static/media/twitter_round.fe06e6325c525fdc267a22ff173da584.svg";
export { ForwardRef as ReactComponent };